import { loadForElements } from '../../_helpers/module-loader';
import initCart from './components/cart';
import initGlobalCss from './components/global-css';

const components = [
    { selector: 'form', callback: () => import('./components/scroll-to-ajax-message') },
    { selector: '.ce_accordion', callback: () => import('./components/accordion') },
    { selector: '.mod_faqpage', callback: () => import('./components/faq') },
    { selector: '.form-floating', callback: () => import('./components/floating-label') },
    { selector: '.mod_app_product_cart', callback: () => import('./components/sticky-add-to-cart') },
    { selector: '.sticky-header', callback: () => import('./components/sticky-header') },

    { selector: '[data-animation]', callback: () => import('./components/animations') },
    { selector: '[data-banner-home]', callback: () => import('./components/banner-home') },
    { selector: '[data-carousel]', callback: () => import('./components/carousels') },
    { selector: '[data-change-body-class]', callback: () => import('./components/change-body-class') },
    { selector: '[data-change-element-class]', callback: () => import('./components/change-element-class') },
    { selector: '[data-counter]', callback: () => import('./components/counters') },
    { selector: '[data-lightbox]', callback: () => import('./components/lightbox') },
    { selector: '[data-snippet]', callback: () => import('./components/syntax-highlighter') },
]

initCart();

document.addEventListener('DOMContentLoaded', () => {
    document.documentElement.classList.add('js');
    initGlobalCss();

    // Initial setup for the existing elements
    components.forEach(component => loadForElements(document.querySelectorAll(component.selector), () => component.callback()));

    // Set up a MutationObserver to detect when new elements are added
    new MutationObserver(mutationsList => mutationsList.forEach(mutation => {
        if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    components.forEach(component => {
                        const elements = [...node.querySelectorAll(component.selector)];

                        // Push the node itself, if it matches the criteria
                        if (node.matches(component.selector)) {
                            elements.push(node)
                        }

                        loadForElements(elements, () => component.callback())
                    })
                }
            });
        }
    })).observe(document.body, { childList: true, subtree: true });
});
